// extracted by mini-css-extract-plugin
module.exports = {"profile":"styles_profile__3Eg0P"};